const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/

const PHONE_PATTERN = /^[+()\-.\s\d]{7,25}$/

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export const isValidEmail = (value: string): boolean => {
    return value.length <= 254 && EMAIL_PATTERN.test(value)
}

export const isValidPhone = (value: string): boolean => {
    return PHONE_PATTERN.test(value) && (value.match(/\d/g)?.length ?? 0) >= 7
}

export const isIsoDate = (value: string): boolean => {
    if (!DATE_PATTERN.test(value)) return false

    const date = new Date(`${value}T00:00:00Z`)

    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value
}

/*
 * Today's date as YYYY-MM-DD in the visitor's own time zone.
 */
export const localIsoDate = (offsetDays = 0): string => {
    const date = new Date()

    date.setDate(date.getDate() + offsetDays)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export const cleanText = (value: unknown, max: number): string => {
    if (typeof value !== 'string') return ''

    return value.replace(/\s+/g, ' ').trim().slice(0, max)
}

export const cleanMultiline = (value: unknown, max: number): string => {
    if (typeof value !== 'string') return ''

    return value.replace(/\r\n?/g, '\n').trim().slice(0, max)
}
